module.exports = __webpack_public_path__ + "img/20171113190935_84300.8f55b6bb.jpg";